import React from 'react';
import { motion } from 'framer-motion';
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function MechanismSection() {
  return <section className="py-14 px-4 bg-white border-t border-navy-100" data-id="element-134">
      <div className="max-w-4xl mx-auto" data-id="element-135">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={fadeIn} className="text-center mb-16" data-id="element-136">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy-900" data-id="element-137">
            Lo que se trabaja en esta sesión
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-138">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-100px'
        }} variants={fadeIn} className="bg-navy-50 p-8 rounded-2xl border border-navy-100" data-id="element-139">
            <h3 className="text-xl font-serif font-bold text-navy-900 mb-4 pb-4 border-b border-navy-200" data-id="element-140">
              Relación espiritual
            </h3>
            <p className="text-navy-700 leading-relaxed" data-id="element-141">
              Culpa, distancia, dirección, valor, merecimiento.
            </p>
          </motion.div>

          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-100px'
        }} variants={fadeIn} className="bg-navy-50 p-8 rounded-2xl border border-navy-100" data-id="element-142">
            <h3 className="text-xl font-serif font-bold text-navy-900 mb-4 pb-4 border-b border-navy-200" data-id="element-143">
              Relación financiera
            </h3>
            <p className="text-navy-700 leading-relaxed" data-id="element-144">
              Escasez, desorden, autosabotaje, cobro, expansión, sostén.
            </p>
          </motion.div>

          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-100px'
        }} variants={fadeIn} className="bg-navy-50 p-8 rounded-2xl border border-navy-100" data-id="element-145">
            <h3 className="text-xl font-serif font-bold text-navy-900 mb-4 pb-4 border-b border-navy-200" data-id="element-146">
              Relación contigo mismo
            </h3>
            <p className="text-navy-700 leading-relaxed" data-id="element-147">
              Disciplina, identidad, consistencia, propósito, liderazgo
              personal.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}